import './Organization.scss';
import OrganizationTree from '@/components/OrganizationTree';
import OrganizationMemberList from '@/components/OrganizationMemberList';
import EventEmitterComponent from '&/components/EventEmitterComponent';

export default function Organization() {
    return (
        <EventEmitterComponent>
            <div type="card" className="base-card-page card basic-info  ">
                <div className="card-content organization-card">
                    <OrganizationTree />
                    <OrganizationMemberList />
                </div>
            </div>
        </EventEmitterComponent>
    );
}
